var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99453 11.1922C11.4305 11.1922 12.5945 10.0281 12.5945 8.59219C12.5945 7.15625 11.4305 5.99219 9.99453 5.99219C8.55859 5.99219 7.39453 7.15625 7.39453 8.59219C7.39453 10.0281 8.55859 11.1922 9.99453 11.1922Z",
    stroke: "url(#paint0_linear_4917_4533)",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.0148 7.0724C4.65646 -0.144269 15.3481 -0.135935 16.9815 7.08073C17.9398 11.3141 15.3065 14.8974 12.9981 17.1141C11.3231 18.7307 8.67313 18.7307 6.9898 17.1141C4.6898 14.8974 2.05646 11.3057 3.0148 7.0724Z",
    stroke: "#1E2328",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4917_4533",
    x1: 7.76768,
    y1: 4.73862,
    x2: 12.7185,
    y2: 5.23147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586388,
    stopColor: "#FC8E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7F7C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.3a4d4e99850b47f3c9df3b96d1ccf9ac.svg";
export { ForwardRef as ReactComponent };